import { render, staticRenderFns } from "./RatesLevyDetails.vue?vue&type=template&id=703eb653&scoped=true&"
import script from "./RatesLevyDetails.vue?vue&type=script&lang=js&"
export * from "./RatesLevyDetails.vue?vue&type=script&lang=js&"
import style0 from "./RatesLevyDetails.vue?vue&type=style&index=0&id=703eb653&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703eb653",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('703eb653')) {
      api.createRecord('703eb653', component.options)
    } else {
      api.reload('703eb653', component.options)
    }
    module.hot.accept("./RatesLevyDetails.vue?vue&type=template&id=703eb653&scoped=true&", function () {
      api.rerender('703eb653', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/RatesLevyDetails.vue"
export default component.exports